var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-booking-table',{attrs:{"title":_vm.$t('global.models.booking.heading'),"subtitle":_vm.$t('global.models.booking.subheading')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }